import { render } from "./ProductSales.vue?vue&type=template&id=7a336dca"
import script from "./ProductSales.vue?vue&type=script&lang=js"
export * from "./ProductSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Sales/ProductSales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a336dca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a336dca', __exports__)) {
    api.reload('7a336dca', __exports__)
  }
  
  module.hot.accept("./ProductSales.vue?vue&type=template&id=7a336dca", () => {
    api.rerender('7a336dca', render)
  })

}


export default __exports__